import React from 'react'
import { Navbar } from '../component/Navbar/Navbar'
import { Footer } from '../component/Footer/Footer'
import { Order_buy2 } from '../component/Order_buy2/Order_buy2'

export const Orders2 = () => {
    return (
        <div>
            <Navbar/>
            <Order_buy2/>
            <Footer/>

            
        </div>
    )
}
